export const clampNumber = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));
export const mmToPx = (mm: number, pxPerMm: number) => mm * pxPerMm;
export const normalizeToArray = <T>(value: T | T[] | undefined | null) => (Array.isArray(value) ? value : []);
export const normalizeKey = (s: string) => s.replace(/\s+/g, " ").toLowerCase().trim();
